import PageLoader from '@Components/PageLoader';
import React, { useCallback, useState } from 'react';
import { StandaloneLoadingContext } from './useStandalonePageLoader';

const StandaloneLoadingProvider: React.FC = ({ children }) => {
	const [activeRequests, setActiveRequests] = useState(0);

	const beginLoading = useCallback(() => {
		setActiveRequests((current) => current + 1);
	}, []);

	const endLoading = useCallback(() => {
		setActiveRequests((current) => Math.max(0, current - 1));
	}, []);

	return (
		<StandaloneLoadingContext.Provider value={{ beginLoading, endLoading }}>
			{activeRequests > 0 && <PageLoader />}
			{children}
		</StandaloneLoadingContext.Provider>
	);
};

export default StandaloneLoadingProvider;
